import { DEFAULT_VARIANT_TITLE } from "@smartrr/shared/constants";

export function isDefaultVariant(purchasableVariantName: string | undefined): boolean {
  if (!purchasableVariantName) {
    return false;
  }

  return purchasableVariantName === DEFAULT_VARIANT_TITLE;
}
